module.exports = __webpack_public_path__ + "assets-cabinet/img/block-card-icon.560e938c.svg";